





















































import { parse } from "date-fns";
import {
  computed,
  defineComponent,
  reactive,
  ref,
  toRefs
} from "@vue/composition-api";

import { Document } from "@/types/documents";
import { ConceptType } from "@/utils/analysis";
import TimelineSlider from "@/components/msa/timeline/TimelineSlider.vue";
import TimelineData from "@/components/msa/timeline/TimelineData.vue";

interface Props {
  documents: Document[];
}

export default defineComponent<Props>({
  name: "TimelineContainer",
  components: {
    TimelineSlider,
    TimelineData
  },
  props: {
    documents: { type: Array, required: true }
  },
  setup(props: Props) {
    const availableTypes = [
      [ConceptType.Disease, "Conditions & Symptoms"],
      [ConceptType.Procedure, "Procedures"],
      [ConceptType.DiagProcedure, "Diag. Procedures"],
      [ConceptType.LabProcedure, "Labs & Vitals"],
      [ConceptType.Drug, "Medications"],
      [ConceptType.Device, "Devices"]
    ];

    const selectedTypes = ref([
      ConceptType.Disease,
      ConceptType.Procedure,
      ConceptType.DiagProcedure,
      ConceptType.LabProcedure,
      ConceptType.Drug,
      ConceptType.Device
    ]);

    const range = ref<[Date, Date] | null>(null);

    const records = computed(() =>
      props.documents
        .flatMap(document =>
          document.items
            .filter(item => item.type === "match")
            .filter(item => selectedTypes.value.includes(item.match.type))
            .map(item => ({ match: item.match, document }))
        )
        .flatMap(item =>
          (item.match.dates.length > 0
            ? item.match.dates
            : [item.document.meta.date]
          )
            .map((date: string) =>
              parse(
                date,
                "y-M-d",
                parse(item.document.meta.date, "y-M-d", new Date())
              )
            )
            .filter((date: Date) => !isNaN(date.getTime()))
            .map((date: Date) => ({
              date,
              name: item.match.description,
              raw: item
            }))
        )
    );

    return { availableTypes, selectedTypes, range, records };
  }
});
